<template>
  <!-- Modal "ověření telefonního čísla přes SMS" -->
  <div class="modal fade" id="phoneVerificationModal" tabindex="-1" role="dialog">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="doVerify()">
          <div class="modal-header">
            <h4>Ověření telefonního čísla</h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
          </div>
          <div class="modal-body">
            <p>
              Jednorázový ověřovací kód byl odeslán SMS zprávou na číslo <code>{{ phoneNumber }}</code>.
            </p>
            <p>
              Zadejte ověřovací kód:
            </p>
            <p style="display: flex; justify-content: center;">
              <input v-model="digits" type="text" inputmode="numeric" autocomplete="one-time-code" maxlength="4" size="4" id="indigits" ref="indigits" placeholder="____" data-1p-ignore>
            </p>
            <p>
              <small>
                Doručení je zpravidla okamžité. V ojedinělých případech může ale trvat až 2-3 minuty.
              </small>
            </p>
          </div>
          <div class="modal-footer">
            <div class="d-flex w-100">
              <div class="flex-grow-1 text-left">
              </div>
              <div>
                <button type="submit" class="btn btn-primary pl-4 pr-4" :disabled="digits.length != 4 || inProgress">
                  Dokončit ověření
                </button>
              </div>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import CustomerResource from '../backend-resources/customer-resource'
import $ from 'jquery';

export default {
  props: {
    index: Number,
  },
  data () {
    return {
      phoneNumber: null,
      digits: '',
      inProgress: false,
    }
  },
  created: function () {
    const phoneNumbers = this.$store.state.customerInfo.phoneNumbers;
    this.phoneNumber = phoneNumbers[this.index].phone;
  },
  mounted: function () {
    this.sendSMS()

    $('#phoneVerificationModal').on('hidden.bs.modal', (e) => {
      this.$emit('finished')
    })

    $('#phoneVerificationModal').on('shown.bs.modal', (e) => {
      $('#indigits').focus()
    })
  },
  methods: {
    sendSMS: function () {
      CustomerResource.sendValidationSMS(this.index).then(() => {
        $('#phoneVerificationModal').modal('show')
      }).catch((e) => {
        if (e.response && e.response.status === 429) {
          alert(`Chyba při odeslání SMS. Příliš mnoho pokusů. Zkuste to prosím později.`)
        } else {
          alert(`Chyba při odeslání SMS. Zkuste to prosím později. ${e}`)
        }
        this.$emit('finished')
      });
    },
    doVerify: function () {
      CustomerResource.checkValidationSMS(this.digits).then(() => {
        $('#phoneVerificationModal').modal('hide')
        this.$emit('verified')
      }).catch((e) => {
        if (e.response && e.response.status === 429) {
          alert(`Příliš mnoho nesprávných pokusů. Zkuste to prosím později.`)
        } else if (e.response && e.response.status === 404) {
          alert(`Nesprávný kód.`)
        } else {
          alert(`Chyba při ověření kódu. Zkuste to prosím později. ${e}`)
        }
        $('#indigits').focus()
      })
    }
  }
}

</script>
<style>

#indigits {
  width: 155pt;
  font-size: 32pt;
  letter-spacing: 12pt;
  font-family: monospace;
  padding: 12pt;
}

</style>



// WEBPACK FOOTER //
// VerifyPhoneNumber.vue?450ca859